import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export interface SearchFilterClasses {
	/** styles applied to the root element */
	root: string;
	rounded: string;
}

export const getSearchFilterUtilityClass = (slot: string) =>
	generateUtilityClass('SearchFilter', slot);

export const searchFilterClasses = generateUtilityClasses('SearchFilter', [
	'root',
	'rounded',
]);
export default searchFilterClasses;
